import { render, staticRenderFns } from "./AccountFavorites.vue?vue&type=template&id=66577c7b"
import script from "./AccountFavorites.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountFavorites.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports